import React from 'react';

const SpherePreview = ({ size = 600, color = '#FFFFFF', options = [] }) => {
  // Scale size for display (600-1800mm -> 100-280px)
  const displaySize = 100 + ((size - 600) / 1200) * 180;
  
  const isHalves = options.includes('halves');
  const hasHanging = options.includes('hanging');
  const isFlat = options.includes('flat');
  const hasRing = options.includes('ring');
  
  return (
    <div className="relative flex items-center justify-center w-full h-full min-h-[300px] md:min-h-[400px]">
      {/* Glow effect */}
      <div 
        className="absolute rounded-full blur-3xl opacity-30"
        style={{
          width: displaySize * 1.5,
          height: displaySize * 1.5,
          backgroundColor: color,
        }}
      />
      
      {/* Hanging wire */}
      {hasHanging && (
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2">
          <div className="w-0.5 bg-zinc-500" style={{ height: `calc(50% - ${displaySize/2}px + 20px)` }} />
          <div className="w-6 h-2 bg-zinc-600 rounded-sm mx-auto -mt-1" />
        </div>
      )}
      
      {/* Main sphere container */}
      <div className="relative flex flex-col items-center" style={{ marginTop: hasHanging ? '40px' : '0' }}>
        {isHalves ? (
          <div className="flex gap-2">
            {/* Left half */}
            <div
              className="sphere-3d sphere-shadow"
              style={{
                width: displaySize / 2,
                height: displaySize,
                backgroundColor: color,
                borderRadius: `${displaySize}px 0 0 ${displaySize}px`,
                clipPath: 'inset(0 0 0 0)',
              }}
            />
            {/* Right half */}
            <div
              className="sphere-3d sphere-shadow"
              style={{
                width: displaySize / 2,
                height: displaySize,
                backgroundColor: color,
                borderRadius: `0 ${displaySize}px ${displaySize}px 0`,
                transform: 'rotateY(180deg)',
              }}
            />
          </div>
        ) : (
          <div className="flex flex-col items-center">
            {/* Main sphere - for flat option, show full sphere with small flat bottom */}
            <div
              className={`sphere-3d sphere-shadow transition-all duration-500`}
              style={{
                width: displaySize,
                height: isFlat ? displaySize * 0.92 : displaySize,
                backgroundColor: color,
                borderRadius: isFlat ? `50% 50% 45% 45%` : '50%',
              }}
            />
            
            {/* Flat bottom plate indicator */}
            {isFlat && (
              <div 
                className="bg-zinc-600 rounded-sm -mt-1"
                style={{ width: displaySize * 0.35, height: 6 }}
              />
            )}
          </div>
        )}
        
        {/* Ring base - improved visualization */}
        {hasRing && !isHalves && (
          <div className="relative mt-3" style={{ width: displaySize * 0.7 }}>
            {/* Ring shadow */}
            <div 
              className="absolute top-1 left-1/2 -translate-x-1/2 bg-black/30 blur-sm rounded-full"
              style={{ 
                width: displaySize * 0.65, 
                height: displaySize * 0.15,
              }}
            />
            {/* Ring outer */}
            <div 
              className="relative mx-auto border-4 border-zinc-500 bg-zinc-700"
              style={{ 
                width: displaySize * 0.7, 
                height: displaySize * 0.18,
                borderRadius: '50%',
                transform: 'perspective(200px) rotateX(70deg)',
                boxShadow: 'inset 0 -4px 8px rgba(0,0,0,0.4), 0 4px 8px rgba(0,0,0,0.3)',
              }}
            />
            {/* Ring label */}
            <div className="text-center mt-2">
              <span className="text-xs text-zinc-500 uppercase tracking-wider">Unterlegring</span>
            </div>
          </div>
        )}
      </div>
      
      {/* Size indicator */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-center">
        <div className="text-xs text-zinc-500 uppercase tracking-widest mb-1">Durchmesser</div>
        <div className="text-2xl font-heading font-bold text-primary">{size} mm</div>
      </div>
    </div>
  );
};

export default SpherePreview;
